import React, { createContext, useContext, useEffect, useState } from 'react';
import { CircularProgress, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import palette from 'src/theme/palette';

export const MyContext = createContext();

export const ContextProvider = ({ children }) => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const userData = localStorage.getItem('user');
    if (userData) {
      setUser(JSON.parse(userData));
    }
    setIsLoading(false);
  }, []);

  // Show a loading indicator or nothing until `useEffect` has finished
  if (isLoading) {
    return (
      <div style={{ height: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <CircularProgress color="primary" />
        {/* <Typography variant="h1">Loading...</Typography> */}
      </div>
    ); // Replace with a spinner or skeleton if needed
  }

  return (
    <MyContext.Provider
      value={{
        user,
        setUser,
      }}
    >
      {children}
    </MyContext.Provider>
  );
};
